// uat
import React, { useState, useRef, useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Webcam from "react-webcam";
import "./CapturePhoto.css"; // New CSS file
import Layout from "./Layout"; // Import Layout

import uploadIcon from "../assets/upload_icon_placeholder.png";
import { useBackground } from '../context/BackgroundContext'; 
// import captureBgDesktop from '../assets/login_page_4k.jpg';
// import captureBgMobile from '../assets/login_phone.jpg';
import captureBgDesktop from '../assets/login_page_4k_latest.jpg';
import captureBgMobile from '../assets/login_phone_long.jpg';

// uat
import { useSessionKey } from '../context/SessionKeyContext';
import { encryptAES } from "../utils/cryptoUtils";
import { useAuth } from '../context/AuthContext';
import { createApiClient } from '../utils/api';


const CapturePhoto = () => {
  const [childName, setChildName] = useState("");
  const [childDream, setChildDream] = useState("");
  const [childDOB, setChildDOB] = useState("");
  const [childGender, setChildGender] = useState("");

  const [useCamera, setUseCamera] = useState(false);
  const [imagePreview, setImagePreview] = useState(null); // base64 preview
  const [file, setFile] = useState(null); // file upload
  const [isLoading, setIsLoading] = useState(false);
  const [isWebcamReady, setIsWebcamReady] = useState(false);
  const webcamRef = useRef(null);
  const fileInputRef = useRef(null);
  const navigate = useNavigate();
  const { changeBackground } = useBackground();
  // uat
  const { sessionKey } = useSessionKey();

  const { apiJwt } = useAuth();
  const apiClient = createApiClient(apiJwt);

  useEffect(() => {
    changeBackground(captureBgDesktop); 
  }, [changeBackground]);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

  useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 600);
  };

  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);

  useEffect(() => {
    changeBackground(isMobile ? captureBgMobile : captureBgDesktop);
  }, [changeBackground, isMobile]);


  useEffect(() => {
    // Clean up object URLs
    return () => {
      if (file && imagePreview && imagePreview.startsWith("blob:")) {
        URL.revokeObjectURL(imagePreview);
      }
    };
  }, [imagePreview]);

  useEffect(() => {
  document.body.style.overflow = "hidden";
  return () => {
    document.body.style.overflow = "auto";
  };
  }, []);


  const capture = useCallback(() => {
    if (webcamRef.current) {
      const screenshot = webcamRef.current.getScreenshot();
      setImagePreview(screenshot);
      setFile(null); 
      setUseCamera(false); 
    }
  }, [webcamRef]);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setImagePreview(URL.createObjectURL(selectedFile)); // Show preview for uploaded file
      setUseCamera(false);
    }
  };

  const clearPhoto = () => {
    if (imagePreview && imagePreview.startsWith("blob:")) {
      URL.revokeObjectURL(imagePreview);
    }
    setImagePreview(null);
    setFile(null);
    setUseCamera(false);
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // Reset file input
    }
  };

  const handleSubmit = async () => {
      if (!childName.trim() ||!childDream.trim() ||!childDOB) {
        alert("Please enter Child's name, dream and dob");
        return;
      }
    if (!imagePreview &&!file) {
      alert("Please capture or upload a photo.");
      return;
    }
    // uat
    if (!sessionKey) { // Essential check for protected route
      alert("Session is not active. Please log in again.");
      navigate('/'); // Redirect to login
      return;
    }
  
    try {
      setIsLoading(true);
      // let responseData;
      let base64ImageString;
      if (imagePreview && imagePreview.startsWith("data:")) {
          base64ImageString = imagePreview.replace(/^data:image\/[a-z]+;base64,/, '');
      } else if (file) {
          base64ImageString = await new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onload = () => resolve(reader.result.split(",")[1]);
              reader.onerror = (error) => reject(error);
              reader.readAsDataURL(file);
          });
      } else {
          throw new Error("No valid image data to upload.");
      }
      
      
      const encryptedPayload = encryptAES(JSON.stringify({ session_challenge_id: sessionKey, image: base64ImageString, text: childDream, gender : childGender }));
      //uat
      // const response = await apiClient.post('https://api-uat.iciciprulife.com/biu/aspireai/upload', {
      //   encryptedRequest: encryptedPayload,
      // });

      //prod
      const response = await apiClient.post('https://api.iciciprulife.com/biu/aspireai/upload', {
        encryptedRequest: encryptedPayload,
      });




    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Server responded with status ${response.status}: ${errorText}`);
    }

    const responseData = await response.blob();
    console.log("Response from server:", responseData);

    const url = URL.createObjectURL(responseData);
    console.log("Response from url", url)

    console.log("Created final displayable image URL:", url);

    sessionStorage.setItem("processedImage", url);
    navigate("/result", { state: { childName, childDream, childDOB, imageUrl: url } });

    } catch (e) {
    console.error("Error during photo submission process:", e);
    alert(e.message || "An unknown error occurred.");
    } finally {
    setIsLoading(false);
    }};

    const openFileDialog = () => {
      fileInputRef.current.click();
    };

    return (
      <Layout specificBackgroundUrl={captureBgDesktop}> {/* Use specificBackgroundUrl prop if Layout supports it */}
          
          {/* NEW WRAPPER: This holds both the card and the button together */}
          <div className="capture-photo-container">
            
            <div className="capture-photo-card-stacked"> {/* Main card for vertical stacking */}
              
              {/* Photo Upload Section */}
              <div className="cp-photo-upload-section">
                <label className="photo-upload-title-cp">Upload child's photo</label>
                <div className="photo-upload-box"> {/* This is the dashed border box */}
                  {useCamera ? (
                    <div className="webcam-area-cp">
                      <Webcam
                        audio={false}
                        ref={webcamRef}
                        screenshotFormat="image/jpeg"
                        onUserMedia={() => setIsWebcamReady(true)}
                        onUserMediaError={(e) => console.error("Webcam error:", e)}
                        className="webcam-view-cp"
                        videoConstraints={{ facingMode: "user" }}
                      />
                    </div>
                  ) : imagePreview ? (
                    <div className="image-preview-area-cp">
                      <img src={imagePreview} alt="Preview" className="image-preview-cp" />
                    </div>
                  ) : (
                    <div className="upload-placeholder-cp" onClick={openFileDialog}>
                      <img src={uploadIcon} alt="Upload Icon" className="upload-icon-cp" />
                      <span>Upload Image</span>
                    </div>
                  )}
                </div>
                
                {/* Buttons for camera/preview control */}
                <div className="photo-action-buttons-container">
                  {useCamera && (
                    <div className="webcam-controls-cp">
                      <button
                        onClick={capture}
                        className="action-button-cp capture-button-cp"
                        disabled={!isWebcamReady}
                      >
                        Capture
                      </button>
                      <button
                        onClick={() => setUseCamera(false)}
                        className="action-button-cp cancel-button-cp"
                      >
                        Cancel
                      </button>
                    </div>
                  )}
                  {(imagePreview || file) && !useCamera && (
                    <button
                    onClick={clearPhoto}
                      className="action-button-cp change-button-cp"
                    >
                      Change Photo
                    </button>
                  )}
                  {!imagePreview && !file && !useCamera && (
                    <button
                      onClick={() => {
                        clearPhoto(); // Clear any existing selection
                        setUseCamera(true);
                      }}
                      className="action-button-cp use-camera-alt-cp"
                    >
                      Use Camera
                    </button>
                  )}
                </div>
    
              </div>
              
              <input
                  type="file"
                  accept="image/*"
                  onChange={handleFileChange}
                  ref={fileInputRef}
                  style={{ display: "none" }}
              />
    
              {/* Input Fields Section */}
              <div className="cp-input-fields-section">
                <div className="input-group-cp">
                  <label htmlFor="childName">Child's name</label>
                  <input
                    type="text"
                    id="childName"
                    placeholder="Type child name here..."
                    value={childName}
                    onChange={(e) => setChildName(e.target.value)}
                  />
                </div>
    
                {/* Gender Radio Buttons */}
                <div className="input-group-cp">
                <label htmlFor="childName">Child's gender</label>
                  <label>
                    <input
                      type="radio"
                      name="gender"
                      value="boy"
                      checked={childGender === "boy"}
                      onChange={(e) => setChildGender(e.target.value)}
                      required
                    />
                    Boy
                  </label>
    
                  <label>
                    <input
                      type="radio"
                      name="gender"
                      value="girl"
                      checked={childGender === "girl"}
                      onChange={(e) => setChildGender(e.target.value)}
                      required
                    />
                    Girl
                  </label>
                </div>
    
                <div className="input-group-cp">
                  <label htmlFor="childDream">Child's dream</label>
                  <input
                    type="text"
                    id="childDream"
                    placeholder="Type child dream here..."
                    value={childDream}
                    onChange={(e) => setChildDream(e.target.value)}
                  />
                </div>
                <div className="input-group-cp">
                  <label htmlFor="childDOB">Child's DOB</label>
                    <input
                      type="text" // Change type to "text"
                      id="childDOB"
                      className="custom-date-input" // Add a new class for specific styling
                      placeholder="YYYY-MM-DD" // Use the placeholder to show the format
                      value={childDOB}
                      onChange={(e) => setChildDOB(e.target.value)}
                    />
                </div>
    
              </div>
    
            </div> {/* END OF CARD */}
            
            {/* BUTTON MOVED HERE: Now sits exactly below the card inside the container */}
            <button onClick={handleSubmit} className="submit-button-cp" disabled={isLoading}>
          {isLoading ? "PROCESSING..." : "GO AHEAD"}
        </button>
    
          </div> {/* END OF WRAPPER */}
    
        </Layout>
      );
    };
    
export default CapturePhoto;


// local testing
// import React, { useState, useRef, useCallback, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import Webcam from "react-webcam";
// import "./CapturePhoto.css"; // New CSS file
// import Layout from "./Layout"; // Import Layout

// import uploadIcon from "../assets/upload_icon_placeholder.png";
// import { useBackground } from '../context/BackgroundContext'; 
// import captureBgDesktop from '../assets/login_page_4k_latest.jpg';
// import captureBgMobile from '../assets/login_phone_long.jpg';


// const CapturePhoto = () => {
//   const [childName, setChildName] = useState("");
//   const [childDream, setChildDream] = useState("");
//   const [childDOB, setChildDOB] = useState("");
//   const [childGender, setChildGender] = useState("");

//   const [useCamera, setUseCamera] = useState(false);
//   const [imagePreview, setImagePreview] = useState(null); // base64 preview
//   const [file, setFile] = useState(null); // file upload
//   const [isLoading, setIsLoading] = useState(false);
//   const [isWebcamReady, setIsWebcamReady] = useState(false);
//   const webcamRef = useRef(null);
//   const fileInputRef = useRef(null);
//   const navigate = useNavigate();
//   const { changeBackground } = useBackground();

//   useEffect(() => {
//     changeBackground(captureBgDesktop); 
//   }, [changeBackground]);

//   const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

//   useEffect(() => {
//   const handleResize = () => {
//     setIsMobile(window.innerWidth <= 600);
//   };

//   window.addEventListener("resize", handleResize);
//   return () => window.removeEventListener("resize", handleResize);
// }, []);

//   useEffect(() => {
//     changeBackground(isMobile ? captureBgMobile : captureBgDesktop);
//   }, [changeBackground, isMobile]);


//   useEffect(() => {
//     // Clean up object URLs
//     return () => {
//       if (file && imagePreview && imagePreview.startsWith("blob:")) {
//         URL.revokeObjectURL(imagePreview);
//       }
//     };
//   }, [imagePreview]);

//   useEffect(() => {
//   document.body.style.overflow = "hidden";
//   return () => {
//     document.body.style.overflow = "auto";
//   };
//   }, []);


//   const capture = useCallback(() => {
//     if (webcamRef.current) {
//       const screenshot = webcamRef.current.getScreenshot();
//       setImagePreview(screenshot);
//       setFile(null); 
//       setUseCamera(false); 
//     }
//   }, [webcamRef]);

//   const handleFileChange = (e) => {
//     const selectedFile = e.target.files[0];
//     if (selectedFile) {
//       setFile(selectedFile);
//       setImagePreview(URL.createObjectURL(selectedFile)); // Show preview for uploaded file
//       setUseCamera(false);
//     }
//   };

//   const clearPhoto = () => {
//     if (imagePreview && imagePreview.startsWith("blob:")) {
//       URL.revokeObjectURL(imagePreview);
//     }
//     setImagePreview(null);
//     setFile(null);
//     setUseCamera(false);
//     if (fileInputRef.current) {
//       fileInputRef.current.value = ""; // Reset file input
//     }
//   };

//   const handleSubmit = async () => {
//     if (!childName.trim() ||!childDream.trim() ||!childDOB) {
//       alert("Please enter Child's name, dream and dob");
//       return;
//     }
//     if (!imagePreview &&!file) {
//       alert("Please capture or upload a photo.");
//       return;
//     }

  
//     try {
//       setIsLoading(true);
//       // let responseData;
//       let base64ImageString;
//       if (imagePreview && imagePreview.startsWith("data:")) {
//           base64ImageString = imagePreview.replace(/^data:image\/[a-z]+;base64,/, '');
//       } else if (file) {
//           base64ImageString = await new Promise((resolve, reject) => {
//               const reader = new FileReader();
//               reader.onload = () => resolve(reader.result.split(",")[1]);
//               reader.onerror = (error) => reject(error);
//               reader.readAsDataURL(file);
//           });
//       } else {
//           throw new Error("No valid image data to upload.");
//       }
      

     
//       // local testing
//       const payload = {
//         image: base64ImageString,
//         text: childDream,
//         gender : childGender
//       };

//       const response = await fetch("http://127.0.0.1:8028/aspireai/upload", {
//           credentials: "include",
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             // 'X-Access-Key': sessionKey,
//           },
//           body: JSON.stringify(payload),
//         });
  
//         if (!response.ok) {
//               const errorText = await response.text();
//               throw new Error(`Server responded with status ${response.status}: ${errorText}`);
//           }
      
//           const responseData = await response.blob();
//           console.log("Response from server:", responseData);
      
//           const url = URL.createObjectURL(responseData);
//           console.log("Response from url", url)
      
//           console.log("Created final displayable image URL:", url);
      
//           sessionStorage.setItem("processedImage", url);
//           navigate("/result", { state: { childName, childDream, childDOB, imageUrl: url } });
      
      
//     } catch (e) {
//     // This catch block will now receive a clear, understandable error message.
//     console.error("Error during photo submission process:", e);
//     alert(e.message || "An unknown error occurred.");
//     } finally {
//     setIsLoading(false);
//     }};

//     const openFileDialog = () => {
//       fileInputRef.current.click();
//     };

//     return (
//       <Layout specificBackgroundUrl={captureBgDesktop}> {/* Use specificBackgroundUrl prop if Layout supports it */}
          
//           {/* NEW WRAPPER: This holds both the card and the button together */}
//           <div className="capture-photo-container">
            
//             <div className="capture-photo-card-stacked"> {/* Main card for vertical stacking */}
              
//               {/* Photo Upload Section */}
//               <div className="cp-photo-upload-section">
//                 <label className="photo-upload-title-cp">Upload child's photo</label>
//                 <div className="photo-upload-box"> {/* This is the dashed border box */}
//                   {useCamera ? (
//                     <div className="webcam-area-cp">
//                       <Webcam
//                         audio={false}
//                         ref={webcamRef}
//                         screenshotFormat="image/jpeg"
//                         onUserMedia={() => setIsWebcamReady(true)}
//                         onUserMediaError={(e) => console.error("Webcam error:", e)}
//                         className="webcam-view-cp"
//                         videoConstraints={{ facingMode: "user" }}
//                       />
//                     </div>
//                   ) : imagePreview ? (
//                     <div className="image-preview-area-cp">
//                       <img src={imagePreview} alt="Preview" className="image-preview-cp" />
//                     </div>
//                   ) : (
//                     <div className="upload-placeholder-cp" onClick={openFileDialog}>
//                       <img src={uploadIcon} alt="Upload Icon" className="upload-icon-cp" />
//                       <span>Upload Image</span>
//                     </div>
//                   )}
//                 </div>
                
//                 {/* Buttons for camera/preview control */}
//                 <div className="photo-action-buttons-container">
//                   {useCamera && (
//                     <div className="webcam-controls-cp">
//                       <button
//                         onClick={capture}
//                         className="action-button-cp capture-button-cp"
//                         disabled={!isWebcamReady}
//                       >
//                         Capture
//                       </button>
//                       <button
//                         onClick={() => setUseCamera(false)}
//                         className="action-button-cp cancel-button-cp"
//                       >
//                         Cancel
//                       </button>
//                     </div>
//                   )}
//                   {(imagePreview || file) && !useCamera && (
//                     <button
//                     onClick={clearPhoto}
//                       className="action-button-cp change-button-cp"
//                     >
//                       Change Photo
//                     </button>
//                   )}
//                   {!imagePreview && !file && !useCamera && (
//                     <button
//                       onClick={() => {
//                         clearPhoto(); // Clear any existing selection
//                         setUseCamera(true);
//                       }}
//                       className="action-button-cp use-camera-alt-cp"
//                     >
//                       Use Camera
//                     </button>
//                   )}
//                 </div>
    
//               </div>
              
//               <input
//                   type="file"
//                   accept="image/*"
//                   onChange={handleFileChange}
//                   ref={fileInputRef}
//                   style={{ display: "none" }}
//               />
    
//               {/* Input Fields Section */}
//               <div className="cp-input-fields-section">
//                 <div className="input-group-cp">
//                   <label htmlFor="childName">Child's name</label>
//                   <input
//                     type="text"
//                     id="childName"
//                     placeholder="Type child name here..."
//                     value={childName}
//                     onChange={(e) => setChildName(e.target.value)}
//                   />
//                 </div>
    
//                 {/* Gender Radio Buttons */}
//                 <div className="input-group-cp">
//                 <label htmlFor="childName">Child's gender</label>
//                   <label>
//                     <input
//                       type="radio"
//                       name="gender"
//                       value="boy"
//                       checked={childGender === "boy"}
//                       onChange={(e) => setChildGender(e.target.value)}
//                       required
//                     />
//                     Boy
//                   </label>
    
//                   <label>
//                     <input
//                       type="radio"
//                       name="gender"
//                       value="girl"
//                       checked={childGender === "girl"}
//                       onChange={(e) => setChildGender(e.target.value)}
//                       required
//                     />
//                     Girl
//                   </label>
//                 </div>
    
//                 <div className="input-group-cp">
//                   <label htmlFor="childDream">Child's dream</label>
//                   <input
//                     type="text"
//                     id="childDream"
//                     placeholder="Type child dream here..."
//                     value={childDream}
//                     onChange={(e) => setChildDream(e.target.value)}
//                   />
//                 </div>
//                 <div className="input-group-cp">
//                   <label htmlFor="childDOB">Child's DOB</label>
//                     <input
//                       type="text" // Change type to "text"
//                       id="childDOB"
//                       className="custom-date-input" // Add a new class for specific styling
//                       placeholder="YYYY-MM-DD" // Use the placeholder to show the format
//                       value={childDOB}
//                       onChange={(e) => setChildDOB(e.target.value)}
//                       required
//                     />
//                 </div>
    
//               </div>
    
//             </div> {/* END OF CARD */}
            
//             {/* BUTTON MOVED HERE: Now sits exactly below the card inside the container */}
//             <button onClick={handleSubmit} className="submit-button-cp" disabled={isLoading}>
//           {isLoading ? "PROCESSING..." : "GO AHEAD"}
//         </button>
    
//           </div> {/* END OF WRAPPER */}
    
//         </Layout>
//       );
//     };
    
// export default CapturePhoto;